import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Form } from "react-bootstrap";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import InputMask from "react-input-mask";

import { useInvoiceContext, useControlContext } from "../context";
import { cnpValidation } from "../utils/cnpValidation";
import { API_BASE_URL } from "../config";
import ButtonNext from "./ButtonNext";

function RENFormCNP(props) {
  const queryString = new URLSearchParams(useLocation().search);
  const querycnp = queryString.get("cnp");

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);

  const { cnp, setCNP, setCustomer } = useInvoiceContext();
  const { showFormCustomer, canInputCNP, setCanInputCNP, setIsNewCustomer } = useControlContext();

  useEffect(
    () => {
      if (querycnp !== null) {
        setCNP(querycnp);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleInputCNP = (event) => {
    setError("");
    setIsInvalid(false);
    setCNP(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (canSubmit()) {  
      fetchCustomer();
    }
  };

  const fetchCustomer = async () => {
    setIsLoading(true);
    setError("");
    setIsInvalid(false);

    try {
      const cnpSanit = cnp.replace(/\D/g, "");
      const response = await fetch(`${API_BASE_URL}/customer/${cnpSanit}`);
      const jsonData = await response.json();

      // console.log(jsonData);
      const status = response.status;

      if (status >= 400 && status < 500) throw new Error(jsonData.message);
      if (status === 500)
        throw new Error(
          "Erro interno do servidor, tente novamente mais tarde.",
        );

      if (jsonData === null)
        throw new Error(
          "Houve um erro inesperado, tente novamente mais tarde.",
        );

      if (status === 202) {
        // NO CONTENT = novo cliente
        setIsNewCustomer(true);
        setCanInputCNP(false);
        setIsLoading(false);
        showFormCustomer(true);
        return;
      }

      if (status === 200) {
        setCanInputCNP(false);
        setIsLoading(false);
        setCustomer(jsonData);
        showFormCustomer(true);
      } else {
        throw new Error("Erro desconhecido, tente novamente mais tarde.");
      }
    } catch (error) {
      setError(error.message);
      setCanInputCNP(true);
      setIsLoading(false);
      setIsInvalid(true);
    }
  };

  const dynamicMask = (value) => {
    try {
      if (!value || value === "" || value.length < 1) return "99999999999999";

      if (value.replace(/\D/g, "").length < 12) {
        return "999.999.999-999999";
      } else {
        return "99.999.999/9999-99";
      }
    } catch (error) {
      console.error("Erro Interno ao Calcular a mascara:", error);
      return "99999999999999";
    }
  };

  const canSubmit = useCallback(() => {
    if (cnp.replace(/\D/g, "").length < 11) {
      return false;
    } else if (cnp.replace(/\D/g, "").length > 14) {
      return false;
    } else if (!cnpValidation(cnp)) {
      return false;
    } else {
      return true;
    }
  }, [cnp]);

  useEffect(() => {
    if (cnp !== null && cnp !== "") {
      if (canSubmit()) {  
        fetchCustomer();
      }
    }

  }, [cnp]);
  
  return (
    <Form className="mt-2 mb-3" onSubmit={handleSubmit}>
      <div className="form-group mb-2">
        <label>CNPJ ou CPF</label>
        <Form.Control
          size="sm"
          type="text"
          value={cnp}
          onChange={(event) => handleInputCNP(event)}
          placeholder="CNPJ ou CPF"
          disabled={!canInputCNP}
          isValid={cnp.length >= 11 && cnpValidation(cnp)}
          isInvalid={(cnp.length >= 11 && !cnpValidation(cnp)) || isInvalid}
          as={InputMask}
          mask={dynamicMask(cnp)}
          maskChar={""}
          // autoFocus = gera um bug junto com o as={InputMask}
        />
        <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
      </div>
      <ButtonNext
        text="Próximo"
        variant="primary"
        className="float-end"
        onClick={handleSubmit}
        hidden={!canInputCNP}
        faicon={faArrowRight}
        isLoading={isLoading}
        disabled={!canSubmit()}
      />
    </Form>
  );
}

export default RENFormCNP;
